import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';

import { Translations } from '../../models';
import { TranslationHttpService } from '../translation-http.service/translation-http.service';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslationLoaderService implements TranslateLoader {
  private readonly translationHttpService = inject(TranslationHttpService);

  getTranslation(): Observable<Translations> {
    return this.translationHttpService.getAllTranslation();
  }
}
